(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["jz-gift-accessories"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('jz-gift-accessories')) {
  class JzGiftAccessories extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;

      this.rail = this.querySelector('[data-rail]');
      this.addButton = this.querySelector('[data-add-selected]');
      this.status = this.querySelector('[data-status]');
      this.checks = Array.from(this.querySelectorAll('[data-gift-check]'));

      this.querySelector('[data-prev]')?.addEventListener('click', () => this.scroll(-1));
      this.querySelector('[data-next]')?.addEventListener('click', () => this.scroll(1));
      this.checks.forEach((check) => check.addEventListener('change', () => this.updateButton()));
      this.addButton?.addEventListener('click', () => this.addSelected());

      this.updateButton();
    }

    scroll(direction) {
      if (!this.rail) return;
      this.rail.scrollBy({
        left: direction * Math.max(170, this.rail.clientWidth * 0.75),
        behavior: 'smooth'
      });
    }

    updateButton() {
      if (!this.addButton) return;
      const count = this.checks.filter((check) => check.checked && !check.disabled).length;
      this.addButton.disabled = count === 0;
    }

    async addSelected() {
      const selected = this.checks.filter((check) => check.checked && !check.disabled);
      if (!selected.length || !this.addButton) return;

      const original = this.addButton.textContent;
      this.addButton.disabled = true;
      this.addButton.textContent = 'Adding…';
      if (this.status) this.status.textContent = '';

      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({
            items: selected.map((check) => ({
              id: Number(check.dataset.variantId),
              quantity: 1
            }))
          })
        });

        if (!response.ok) throw new Error('Unable to add selected gifts');

        selected.forEach((check) => {
          check.checked = false;
        });

        if (this.status) this.status.textContent = 'Selected gifts added to cart.';
        document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true }));
      } catch (error) {
        if (this.status) this.status.textContent = error.message || 'Unable to add selected gifts.';
      } finally {
        this.addButton.textContent = original;
        this.updateButton();
      }
    }
  }

  customElements.define('jz-gift-accessories', JzGiftAccessories);
}
  } catch(e) { console.error(e); }
})();

})();
